
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'MultibrandMenu',
  props: {
    config: Object,
  },
  mounted() {
    this.separateBrands()
    if (this.appInfo?.menu?.is_multibrand && !this.ActiveSuperCategory) {
      this.setActiveSuperCategory(this.appInfo?.name)
    }
  },
  computed: {
    ...mapState([ 'location', 'appInfo', 'categoryBrands', 'ActiveSuperCategory', 'filteredMenu', 'menu' ]),
    AllCategories() {
      if (this.filteredMenu && this.filteredMenu.length > 0) {
        return this.filteredMenu
      }

      return this.menu.categories
    },
  },
  methods: {
    ...mapMutations([ 'setCategoryBrands', 'setActiveSuperCategory' ]),
    separateBrands() {
      if (this.appInfo?.menu?.is_multibrand && this.location && this.AllCategories) {
        let brands = []
        // Check if there is a default brand image in config
        const defaultImage = this.config?.brands?.find(b => b?.brand === this.appInfo?.name)

        // Push default brand
        const brand = {
          id: this.location.id,
          name: this.appInfo?.name,
          category: this.appInfo?.name,
          image: defaultImage ? defaultImage?.logo : ''
        }
        brands.push(brand)

        this.AllCategories.map(c => {
          // Check if category has super_cagory item, super_category is not the same as app name and has products
          if ( c.super_category && c.super_category !== this.appInfo?.name && c.products.length > 0 ) {
            // Check if there is a brand image in config
            const image = this.config?.brands?.find(b => b?.brand === c.super_category)
            let brandImage = null

            // Check if there's an image in the category
            if (c.images.length > 0) {
              brandImage = c.images[0]
            }
            else if (image) {
              brandImage = image?.logo
            }

            // Push brand
            const brand = {
              id: c.id,
              name: c.name,
              category: c.super_category,
              image: brandImage ? brandImage : ''
            }
            brands.push(brand)
          }
        })

        // Check if brands are unique
        if (this.categoryBrands && this.categoryBrands > 0) {
          const result = this.categoryBrands.some(o => !brands.some(v => v.id === o.id));

          if (!result) {
            this.setCategoryBrands(null)
            this.setCategoryBrands(brands)
          }
        }
        else {
          this.setCategoryBrands(brands)
        }
      }
    },
    activeSuperCategory(item) {
      this.setActiveSuperCategory(item)
    }
  }
}
